<template>
  <div class="solution-security">
    <div class="banner">
      <solution-banner :bannerInfo="bannerConstant.SolutionEducation"></solution-banner>
    </div>
    <div class="solution-bar" :class="{'is-fixed': secondNavFixed}">
      <div class="anchors-items">
        <div class="anchors-item" :class="{'active-anchors' : index == indexActive}"
          v-for="(item, index) in AnchorsItems" :key="index" @click="goAnchor('#anchor-'+index, index)">
          {{item}}
        </div>
      </div>
    </div>
    <div class="solution-bar-place" v-if="secondNavFixed"></div>
    <div id="anchor-0" class="items-details">
      <div class="solution-title">
        {{AnchorsItems[0]}}
      </div>
      <div class="solution-content-intro-education">
          <div class="content">
            优图实验室依托业界领先的深度学习技术，面向教育行业推出OCR解决方案，为不同学力、不同学科的教学任务提供更智慧的教学工具与更便捷的用户体验，助力教育机构能力升级，提升学生的学习效率。
          </div>
      </div>
    </div>
    <div id="anchor-1" class="items-details">
      <div class="solution-title">
        {{AnchorsItems[1]}}
      </div>
      <div class="core-competence">
        <div class="core-competence-item"
          :class="{'core-even': (index % 2 == 0), 'last-core' : (index == (coreCompetence.length - 1))}"
          :style="{backgroundImage:'url(' + item.imgUrl + ')'}"
          v-for="(item, index) in coreCompetence"
          :key="index">
          <div class="core-img" ></div>
          <div class="core-title">
            {{item.title}}
          </div>
          <div class="core-content">
            {{item.content}}
          </div>
        </div>
      </div>
    </div>
    <div id="anchor-2" class="items-details">
      <div class="solution-title">
        {{AnchorsItems[2]}}
      </div>
      <div class="advantage-container">
        <scheme-advantage :advantageInfo="advantageConstant.SolutionEducation"></scheme-advantage>
      </div>
    </div>
    <div id="anchor-3" class="items-details">
      <div class="solution-title">
        {{AnchorsItems[3]}}
      </div>
      <div class="application-container">
        <application-scene :sceneInfo="applicationConstant.SolutionEducation"></application-scene>
      </div>
    </div>
  </div>
</template>

<script>
import SolutionBanner from '../common/SolutionBanner';
import SchemeAdvantage from '../common/SchemeAdvantage';
import ApplicationScene from '../common/ApplicationScene';
import bannerConstant from './data/BannerConstant';
import advantageConstant from './data/AdvantageConstant';
import applicationConstant from './data/ApplicationConstant';
import ScrollManager from '@/components/open/common/ScrollManager';
import HandleAnchor from './js/HandleAnchor';

const coreCompetence = [
  {
    title: '高精度中文文本识别能力',
    content: '支持全学科的中文文本文字识别，单字精度>95%。',
    imgUrl: require('./img/education/image_jyocr01.jpg')
  }, {
    title: '高精度英文文本识别能力',
    content: '支持手写/印刷英文文本文字识别，单字精度>95%。',
    imgUrl: require('./img/education/image_jyocr02.jpg')
  }, {
    title: '高精度算式/公式检测能力',
    content: '支持手写/印刷格式的小学数学算式与印刷格式的初中/高中/大学理科公式的检测能力，准确率>97%。',
    imgUrl: require('./img/education/image_jyocr03.jpg')
  }, {
    title: '高精度理科公式识别能力',
    content: '支持识别91种印刷格式的初中/高中/大学公式类型，支持180种字符的识别，单字精度>95%, 全字段精度>85%，输出基于Latex语法的公式文本。',
    imgUrl: require('./img/education/image_jyocr04.jpg')
  }, {
    title: '高精度速算算式识别能力',
    content: '支持识别14种印刷/手写格式的小学速算算式类型，单字精度>95%。',
    imgUrl: require('./img/education/image_jyocr05.jpg')
  }
];

export default {
  name: '',
  components: {
    SolutionBanner,
    SchemeAdvantage,
    ApplicationScene
  },
  data() {
    return {
      bannerConstant,
      advantageConstant,
      applicationConstant,
      coreCompetence,
      AnchorsItems: ['方案介绍', '核心能力', '方案优势', '应用场景'],
      secondNavFixed: false,
      indexActive: 0
    };
  },
  methods: {
    handleMouseScroll(param) {
      HandleAnchor.mouseScroll(param, this);
    },
    goAnchor(selector, index) {
      HandleAnchor.mouseClick(selector, index, this);
    }
  },
  mounted() {
    ScrollManager.register(this.handleMouseScroll);
  },
  beforeDestroy() {
    ScrollManager.degister(this.handleMouseScroll);
  }
};
</script>

<style lang="less" scoped>
.solution-security {
  font-size: 14px;
  color: #333333;
  div {
    box-sizing: border-box;
  }
  .banner {
    height: 482px;
  }
  .solution-bar-place{
    height: 60px;
    width: 100%
  }
  .solution-bar {
    width: 100%;
    min-width: 1200px;
    height: 60px;
    overflow: hidden;
    z-index: 2;
    background-color: #ffffff;
    border-bottom: 1px solid #eeeeee;
    .anchors-items {
      font-size: 0;
      text-align: center;
      .anchors-item {
        cursor: pointer;
        display: inline-block;
        margin: 0 45px;
        font-size: 17px;
        line-height: 50px;
        padding-top: 5px;
        &:hover {
          color: #00a6ff;
          border-bottom: 4px solid #00a6ff;
        }
        &.active-anchors{
          color: #00a6ff;
          border-bottom: 4px solid #00a6ff;
        }
      }
    }
    &.is-fixed{
      position: fixed;
      top: 63px;
      z-index: 1;
    }
  }
  .items-details{
    padding-bottom: 70px;
    overflow: hidden;
  }
  .core-competence{
    width: 1170px;
    margin: 0 auto;
    overflow: hidden;
    font-size: 0;
    .core-competence-item{
      vertical-align: top;
      width: 570px;
      height: 510px;
      margin-bottom: 30px;
      padding: 336px 20px 0 20px;
      display: inline-block;
      background-repeat: no-repeat;
      border: #e6e6e6 1px solid;
      color: #242526;
      &.core-even{
        margin-right: 30px;
      }
      &.last-core{
        margin-bottom: 0;
      }
      .core-title{
        font-size: 24px;
        line-height: 1.0;
        text-align: center;
      }
      .core-content{
        line-height: 1.8;
        font-size: 16px;
        text-align: justify;
        margin-top: 36px;
      }
    }
  }
  .solution-title{
    margin-top: 70px;
    margin-bottom: 40px;
    font-size: 30px;
    color: #333;
    text-align: center;
    line-height: 1.0;
  }
  .solution-content-intro-education{
    width: 1170px;
    margin: 0 auto;
    color: #212121;
    .content{
      font-size: 16px;
      line-height: 1.8;
      text-align: justify;
    }
    .img-title {
      margin-top: 58px;
      margin-bottom: 26px;
      font-size: 16px;
      font-weight: bold;
      line-height: 1.0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/solution/panels/SolutionEducation.vue